import * as React from "react";
import { FunctionComponent, useContext } from "react";
import { SliderItemProps, SliderItemOnInteractInnerProps } from "./interfaces";
import { Block, IColors, Icon, theme } from "../../../seenspire-library";
import { AppContext } from "../../state";
import { SliderItemButton } from "./Styles";
import { useTranslation } from "react-i18next";

const SliderSubmitButton: FunctionComponent<
  SliderItemProps & SliderItemOnInteractInnerProps
> = ({ canSubmit, status, renderStatusColor, submit, customButtonText }) => {
  const { t } = useTranslation();
  const { hasRole } = useContext(AppContext);

  let iconName: "add" | "loading" | "checkDark" = "add";
  let iconSize: "smaller" | "smallest" = "smaller";
  let iconFill = undefined;
  let iconStrokeColor: keyof IColors | undefined = undefined;

  if (status === "IN_PROGRESS") {
    iconName = "loading";
    iconSize = "smaller";
    iconStrokeColor = "white";
  }

  if (status === "DONE") {
    iconName = "checkDark";
    iconSize = "smallest";
    iconFill = theme.colors.black.darkest;
  }

  return (
    <SliderItemButton
      className={"seens__slider__feed__submit-button"}
      cursor={canSubmit ? "pointer" : "not-allowed"}
      disabled={!canSubmit || status === "IN_PROGRESS"}
      opacity={canSubmit && status !== "DISABLED" ? 1 : 0.5}
      elementHeightBase={false}
      onClick={submit}
      buttonType={renderStatusColor()}
      elementWidth="block"
      icon={iconName}
      iconProps={{
        iconSize,
        iconFill,
        strokeColor: iconStrokeColor,
        margin: { right: 0 },
      }}
    >
      <Block fontSize="smaller" as="span">
        {status === "INIT" && (customButtonText || t("feeds.add_to_my_feeds"))}
        {status === "DISABLED" && "Coming soon"}
        {status === "NO_STATION_FOUND" && "No stations found"}
        {status === "IN_PROGRESS" && t("feeds.adding_feeds")}
        {status === "DONE" && t("FEED ADDED")}
        {status === "FAILED" && (hasRole("ROLE_CURATOR") ? t("This action isn’t allowed for your role.") : t("Something went wrong!"))}
      </Block>
    </SliderItemButton>
  );
};

export default SliderSubmitButton;
